<template>
    <div>
        <v-data-table :headers="headersTabela" :items="itens" hide-actions
                      class="az-table-list table-itens">
            <template slot="items" slot-scope="props">
                <td>
                    {{ props.item.sequencia }}
                </td>
                <td>
                    {{ props.item.codigo }}
                </td>
                <td>
                    <expansao-texto :tamanho="tamanho" :texto="props.item.descricao"/>
                </td>
                <td align="right">
                    {{ props.item.unidade }}
                </td>
                <td align="right">
                    {{ props.item.quantidade | cdCurrency('', qtdeCasasDecimais(casasDecimaisQuantidade)) }}
                </td>
                <td v-if="possuiValorReferencia" align="right">
                    {{ props.item.valorEstimado | cdCurrency(prefix, casasDecimais) }}{{suffix}}
                </td>
                <td v-if="possuiValorReferencia && !isCriterioJulgamentoMaiorDesconto" align="right">
                    {{ props.item.totalEstimado | cdCurrency(prefix, casasDecimais) }}{{suffix}}
                </td>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: 'PainelLoteEdicaoTabela',
    props: ['itens', 'casasDecimais', 'prefixOuSuffixValor', 'criterioJulgamento', 'isCriterioJulgamentoMaiorDesconto', 'possuiValorReferencia', 'casasDecimaisQuantidade'],
    data() {
        return {
            tamanho: null
        }
    },
    computed: {
        ...mapState(['loki']),
        headersTabela(){
            return [
                {
                    sortable: true,
                    value: 'sequencia',
                    text: 'Seq',
                    width: '5%',
                    class: 'primary--text',
                    align: 'left'
                },
                {
                    sortable: false,
                    text: 'Código',
                    align: 'left',
                    width: '5%',
                    value: 'codigo',
                    class: 'primary--text'
                },
                {
                    align: 'left',
                    sortable: false,
                    width: '40%',
                    text: 'Descrição',
                    value: 'descricao',
                    class: 'primary--text'
                },
                {
                    width: '10%',
                    value: 'unidade',
                    align: 'right',
                    sortable: false,
                    text: 'Unidade',
                    class: 'primary--text'
                },
                {
                    sortable: false,
                    align: 'right',
                    text: 'Qtd',
                    width: '10%',
                    value: 'quantidade',
                    class: 'primary--text'
                },
                ... this.possuiValorReferencia ? [{
                    value: 'valorEstimado',
                    text: this.isCriterioJulgamentoMaiorDesconto ? 'Estimado Unit. (%)' :  'Estimado Unit. (R$)',
                    width: '10%',
                    align: 'right',
                    sortable: false,
                    class: 'primary--text'
                }] : [],
                ... this.possuiValorReferencia && !this.isCriterioJulgamentoMaiorDesconto ? [{
                    value: 'estimado_total',
                    align: 'right',
                    width: '10%',
                    text: 'Estimado Total (R$)',
                    sortable: false,
                    class: 'primary--text'
                }] : [],
            ]
        },
        prefix(){
            return this.prefixOuSuffixValor === 'R$' ? 'R$ ' : ''
        },
        suffix(){
            return this.prefixOuSuffixValor === '%' ? '%' : ''
        }
    },
    created() {
        window.addEventListener('resize', this.pegarTamanho)
        this.pegarTamanho()
    },
    destroyed() {
        window.removeEventListener('resize', this.pegarTamanho)
    },
    methods: {
        pegarTamanho() {
            this.tamanho = .120 * window.innerWidth
        }
    }
}
</script>

<style scoped lang="stylus">
    .table-itens, .table-itens-manual
        border-top 1px solid #ebebeb
        padding 16px

    @media (max-width 720px)
        .table-itens, .table-itens-manual
            padding 0

            td:nth-of-type(1):before
                content "Sequência:"

            td:nth-of-type(4)
                text-align left

            td:nth-of-type(5)
                text-align left

            td:nth-of-type(6)
                text-align left

        .table-itens
            td:nth-of-type(2):before
                content "Código:"

            td:nth-of-type(3):before
                content "Descrição:"

            td:nth-of-type(4):before
                content "Unidade:"

            td:nth-of-type(5):before
                content "Quantidade:"

            td:nth-of-type(6):before
                content "Estimado Unitário (R$):"

            td:nth-of-type(7):before
                content "Estimado Total (R$):"

            td:nth-of-type(7)
                text-align left

        .table-itens-manual
            td:nth-of-type(2):before
                content "Descrição:"

            td:nth-of-type(3):before
                content "Unidade:"

            td:nth-of-type(4):before
                content "Quantidade:"

            td:nth-of-type(5):before
                content "Estimado Unitário (R$):"

            td:nth-of-type(6):before
                content "Estimado Total (R$):"

            td:nth-of-type(3)
                text-align left
</style>
